import { Navigation } from "fond/projects/Navigation";
import { PageContent } from "fond/widgets";

import AccountList from "./AccountList";

const Accounts: React.FC = () => {
  return (
    <PageContent
      windowTitle="Workspaces"
      title="Workspaces"
      subTitle="Member and external workspaces"
      mainContent={<AccountList />}
      testId="account-list"
      navigation={<Navigation />}
    />
  );
};

export default Accounts;
